<template>
  <div>
   <AppSidebar />
    <div class="wrapper d-flex flex-column min-vh-100 bg-light">
      <CIcon icon="cil" size="lg" @click="$store.commit('toggleSidebar')" />
      <!--<CHeader position="sticky" class="mb-4">
        <CContainer fluid>
          <CHeaderToggler class="ps-1" @click="$store.commit('toggleSidebar')">
            <CIcon icon="cil-menu" size="lg" />
          </CHeaderToggler>
        </CContainer>
      </CHeader>-->
       
      <!--<AppHeader />-->
      <div class="body flex-grow-1 px-3 py-3 body-custom" style="">
        <CContainer fluid>
          <TheReminder/>
          <router-view />
        </CContainer>
      </div>
      <AppFooter />
    </div>
  </div>
</template>
<script>
import { CContainer } from '@coreui/vue'
//import AppFooter from '@/components/AppFooter.vue'
//import AppHeader from '@/components/AppHeader.vue'
import AppSidebar from '@/components/AppSidebar.vue'
import TheReminder from '@/components/TheReminder.vue'

export default {
  name: 'DefaultLayout',
  components: {
    //AppFooter,
    //AppHeader,
    AppSidebar,
    CContainer,
    TheReminder,
  },
}
</script>
<style>
  .header {
    --cui-header-bg: rgb(235, 237, 239);
  }

  .wrapper{
    background: linear-gradient(to bottom, #171f48, #171f48) !important;
  }

  .body-custom {
    background-color: oklch(98.5% .002 247.839);
    border-radius: 14px; 
    margin-top: -11px;
  }
</style>